import { render } from "./HeaderMatches.vue?vue&type=template&id=7b69bef8"
import script from "./HeaderMatches.vue?vue&type=script&lang=js"
export * from "./HeaderMatches.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__